import {ExtensionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as net from 'util/Net';

import {type Extension} from './extensionConstants';

export const EXTENSION_URL_BASE = '/1/api/extension-definitions';

export function submitExtensionDirectoryInstall(
  extension: Extension,
  urlParamValues?: Record<string, string>
): Promise<unknown> {
  const data: {extensionType: Extension['extensionType']; urlParamValues?: Record<string, string>} = {
    extensionType: extension.extensionType,
  };
  if (extension.extensionType === ExtensionType.MCP_SERVER && urlParamValues != null) {
    data.urlParamValues = urlParamValues;
  }
  return net.postJSONPromise({
    url: `${EXTENSION_URL_BASE}/${extension.id}:install`,
    data,
  });
}

export function parseNonEmptyInstallationId(raw: unknown): string | undefined {
  return typeof raw === 'string' && raw !== '' ? raw : undefined;
}

/**
 * Merges a non-empty install API id into the listing row so {@link ContentStoreModal} `onInstall`
 * receives an up-to-date `installationId`. Pass the raw `installationApiId` value (or `unknown`).
 */
export function extensionWithInstallationId(extension: Extension, installationApiIdRaw: unknown): Extension {
  const id = parseNonEmptyInstallationId(installationApiIdRaw);
  if (id == null) {
    return extension;
  }
  return {...extension, installationId: id};
}

export function extensionWithInstallationIdFromInstallResponse(
  extension: Extension,
  response: unknown
): Extension {
  return extensionWithInstallationId(
    extension,
    (response as {installationApiId?: unknown} | null | undefined)?.installationApiId
  );
}

export function resolveMcpSetupRedirectInfo(
  extension: Extension
): {serverId: string; displayName: string} | undefined {
  if (extension.extensionType !== ExtensionType.MCP_SERVER) {
    return undefined;
  }
  const serverId = parseNonEmptyInstallationId(extension.installationId);
  if (serverId == null) {
    return undefined;
  }
  return {serverId, displayName: extension.displayName};
}
